/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { FC } from 'react'
import { toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { Hawala } from '../../core/_models'

type Props = {
  hawala: Hawala
}

const HawalaInfoCell: FC<Props> = ({ hawala }) =>{
  return(
    <div className='d-flex align-items-center'>
      {/* begin:: Avatar */}
      <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
        <a href='#'>
          {hawala.reseller?.profile_image_url ? (
            <div className='symbol-label'>
              <img src={`${hawala.reseller?.profile_image_url}`} alt={hawala.reseller?.reseller_name} className='w-100' />
            </div>
          ) : (
            <div
              className={clsx(
                'symbol-label fs-3',
                `bg-light-${hawala.reseller?.reseller_name}`,
                `text-${hawala.reseller?.reseller_name}`
              )}
            >
            </div>
          )}
        </a>
      </div>
      <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-primary mb-1'>
          {hawala.reseller?.reseller_name}
        </a>
        {/* <span>{hawala.reseller.reseller_name}</span> */}
      </div>
    </div>
  )
}

export { HawalaInfoCell }
